import { render } from "./SiteConfigEdit.vue?vue&type=template&id=6bd79562"
import script from "./SiteConfigEdit.vue?vue&type=script&lang=js"
export * from "./SiteConfigEdit.vue?vue&type=script&lang=js"

import "./SiteConfigEdit.vue?vue&type=style&index=0&id=6bd79562&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__